/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StationOrLocationItem
 */
export interface StationOrLocationItem {
    /**
     * 
     * @type {boolean}
     * @memberof StationOrLocationItem
     */
    isLocation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StationOrLocationItem
     */
    effective?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StationOrLocationItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StationOrLocationItem
     */
    label?: string | null;
}

export function StationOrLocationItemFromJSON(json: any): StationOrLocationItem {
    return StationOrLocationItemFromJSONTyped(json, false);
}

export function StationOrLocationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationOrLocationItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isLocation': !exists(json, 'isLocation') ? undefined : json['isLocation'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function StationOrLocationItemToJSON(value?: StationOrLocationItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isLocation': value.isLocation,
        'effective': value.effective,
        'code': value.code,
        'label': value.label,
    };
}


